export const MIN_PDF_SCALE = 0.4
export const MAX_PDF_SCALE = 3

export function calculateFitWidthScale(containerWidth, pageWidth, horizontalPadding = 48) {
  if (!Number.isFinite(containerWidth) || !Number.isFinite(pageWidth) || pageWidth <= 0) {
    return MIN_PDF_SCALE
  }
  const availableWidth = Math.max(containerWidth - horizontalPadding, 1)
  return Math.min(MAX_PDF_SCALE, Math.max(MIN_PDF_SCALE, availableWidth / pageWidth))
}

export function clampPdfScale(scale) {
  return Math.min(MAX_PDF_SCALE, Math.max(MIN_PDF_SCALE, scale))
}

/**
 * Pick the page whose top has most recently passed the viewer's reading line.
 * Positions must be in document order. Prefetch/intersection events are not
 * a reliable indicator of the page that the user is actually reading.
 */
export function getPageAtScrollPosition(pagePositions, activationLine) {
  if (!pagePositions.length) return 1

  let currentPage = pagePositions[0].pageNumber
  for (const { pageNumber, top } of pagePositions) {
    if (top > activationLine) break
    currentPage = pageNumber
  }
  return currentPage
}
